import { c as ce } from "./chunks/index.js";
const inputClasses = ce({
  slots: {
    input: "w-full rounded border-0 bg-surface text-night ring-1 ring-inset ring-p-gray-30 placeholder:text-p-gray-40 hover:ring-primary focus:outline-none focus:ring-2 focus:ring-primary disabled:cursor-default disabled:bg-p-blue-10 disabled:ring-p-gray-30 disabled:hover:ring-p-gray-30",
    label: "mb-1 block font-medium",
    errorMessage: "mt-1 text-xs text-on-error"
  },
  variants: {
    size: {
      sm: {
        input: "h-8 pl-3 pr-3 text-sm",
        label: "text-xs"
      },
      md: {
        input: "h-10 pl-4 pr-4 text-base",
        label: "text-sm"
      },
      lg: {
        input: "h-12 pl-5 pr-5 text-lg",
        label: "text-base"
      }
    },
    prefix: {
      true: "pl-8"
    },
    suffix: {
      true: "pr-6"
    },
    required: {
      true: {
        label: `after:text-on-error after:content-["_*"]`
      }
    },
    error: {
      true: {
        input: "ring-on-error hover:ring-on-error focus:ring-on-error"
      }
    },
    rounded: {
      true: {
        input: "rounded-full"
      }
    }
  },
  compoundVariants: [
    {
      size: "sm",
      prefix: true,
      class: {
        input: "pl-6"
      }
    },
    {
      size: "md",
      prefix: true,
      class: {
        input: "pl-8"
      }
    },
    {
      size: "lg",
      prefix: true,
      class: {
        input: "pl-12"
      }
    },
    {
      size: "sm",
      suffix: true,
      class: {
        input: "pr-6"
      }
    },
    {
      size: "md",
      suffix: true,
      class: {
        input: "pr-8"
      }
    },
    {
      size: "lg",
      suffix: true,
      class: {
        input: "pr-12"
      }
    }
  ],
  defaultVariants: {
    size: "md"
  }
});
const textareaClasses = ce({
  extend: inputClasses,
  slots: {
    input: "resize-y overflow-auto"
  },
  variants: {
    size: {
      sm: {
        input: "h-auto py-2"
      },
      md: {
        input: "h-auto py-3"
      },
      lg: {
        input: "h-auto py-4"
      }
    }
  }
});
const selectClasses = ce({
  extend: inputClasses,
  slots: {
    input: "squirrel-bg-chevron-down appearance-none truncate bg-no-repeat"
  },
  variants: {
    size: {
      sm: {
        input: "bg-[position:right_0.675rem_center] pr-8"
      },
      md: {
        input: "bg-[position:right_1rem_center] pr-10"
      },
      lg: {
        input: "bg-[position:right_1.25rem_center] pr-12"
      }
    }
  }
});
export {
  inputClasses,
  selectClasses,
  textareaClasses
};
